'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _addClassName = require('../utils/add-class-name');

var _addClassName2 = _interopRequireDefault(_addClassName);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _namespaceOptions = require('../utils/namespace-options');

var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstContainer = function (_VstComponent) {
  _inherits(VstContainer, _VstComponent);

  function VstContainer() {
    _classCallCheck(this, VstContainer);

    return _possibleConstructorReturn(this, (VstContainer.__proto__ || Object.getPrototypeOf(VstContainer)).apply(this, arguments));
  }

  _createClass(VstContainer, [{
    key: 'render',
    value: function render() {
      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), 'vst-container'));
      props = (0, _copyProps2.default)(props, ['options']);

      return _react2.default.createElement(
        'div',
        _extends({ className: 'vst-container' }, props),
        this.props.children
      );
    }
  }]);

  return VstContainer;
}(_VstComponent3.default);

module.exports = VstContainer;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstContainer.js
 **/